import { ContentBlock } from "./contentBlock";

export type TextTriadType = {
    _type: 'textTriad';
    _key: string;
    title: string;
    textBlock: Array<{
        triadTitle: string;
        text: string;
    }>;
}

export const isTextTriad = (block: ContentBlock): block is TextTriadType => {
    return block._type === 'textTriad';
}
